import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { createDTHEQuotation, updateDTHEQuotation } from 'src/_helpers/api';

const name = 'dtheQuotations';

const initialState = {
  quotations: [],
  error: null,
};

const addDTHEQuotationAsync = createAsyncThunk(

	`${name}/add-dthe-quotation`,
	async (quotationData) => {
		//console.log("Inside addDTHEQuotationAsync")
		// prendre la date d'aujourd'hui avec le bon format au lieu du formattage de JS pour le .json
		const monthNames = ["Jan", "Fev", "Mar", "Avr", "Mai", "Juin",
			"Juillet", "Aout", "Sep", "Oct", "Nov", "Dec"
		];
		const today = new Date();
		const day = `${today.getDate() < 10 ? "0" : ""}${today.getDate()}`;
		const year = today.getFullYear();
		const hours = today.getHours();
		const minutes = today.getMinutes();

		const formattedDate = `${day}/${monthNames[today.getMonth()]}/${year} ${hours}:${minutes}`;

		console.log("slice quotationData: ", quotationData)

		// Construire l'objet commun pour la création ou la mise à jour
		const apiDataCommon = {
			AirFlowType: quotationData.airFlowType,
			Application: quotationData.application,
			CFMHighVolume: quotationData.CFMHighVolume,
			CFMMinVolume: quotationData.CFMMinVolume,
			CancelPrecedentVersion: quotationData.cancelPrecedentVersion,
			City:
				quotationData.shipping !== 'Not Included' || quotationData.startUp !== 'Not Included'
					? quotationData.city
					: null,
			ContactName: quotationData.contactName || null,
			Controls: quotationData.controls,
			AirFlowControl: quotationData.airFlowControl,
			HeatControl: quotationData.heatControl,
			Damper: quotationData.damper,
			Country:
				quotationData.shipping !== 'Not Included' || quotationData.startUp !== 'Not Included'
					? quotationData.country
					: null,
			Customer: quotationData.customer || "",
			FilterLocation: quotationData.filterLocation,
			DirtyFilterContact: quotationData.dirtyFilterContact,
			CoolingSection: quotationData.coolingSection,
			DischargeLocation: quotationData.dischargeLocation,
			ExternalStaticPressure: quotationData.externalStaticPressure,
			GasType: quotationData.gasType,
			Installation: quotationData.installation,
			Margin: quotationData.margin,
			MotorSecurityFactor: quotationData.motorSecurityFactor,
			NumberUnits: quotationData.numberUnits,
			OAEADamper: quotationData.oaeaDamper,
			ProductName: quotationData.productName,
			Product_id: quotationData.product_id,
			ProjectName: quotationData.projectName,
			ProjectNumber: quotationData.projectNumber,
			Province:
				quotationData.shipping !== 'Not Included' || quotationData.startUp !== 'Not Included'
					? quotationData.province
					: null,
			QuotationStatus: quotationData.quotationStatus,
			QuoteDate: formattedDate,
			Representative: quotationData.representative || null,
			Shipping: quotationData.shipping,
			StartUp: quotationData.startUp,
			RoofCurb: "Not Included",
			LeadTime: quotationData.leadTime,
			SubmittedBy: quotationData.submittedBy,
			CompanyOffice: quotationData.companyOffice,
			SubmittedBy: quotationData.submittedBy,
			TemperatureRise: quotationData.temperatureRise,
			Template_id: quotationData.template_id,
			UnitDesignation: quotationData.unitDesignation,
			UserId: quotationData.UserId,
			Voltage: quotationData.voltage,
			Model: quotationData.model,
			GasTrainType: quotationData.gasTrainType,
			ControlMode: quotationData.controlMode,
			DisconnectSwitch: quotationData.disconnectSwitch,
			AccessControl: quotationData.accessControl,
			
		};

		console.log("slice apiDataCommon: ", apiDataCommon)

		// Vérifier si on est en "création" ou en "révision"
		let response;
		if (quotationData.id) {

			//console.log("quotationData.id is defined: ", quotationData.id)

			const apiDataForUpdate = {
				DTHEQuoteCode: quotationData.quote,
				...apiDataCommon,
			};
			response = await updateDTHEQuotation(apiDataForUpdate);
		} else {

			response = await createDTHEQuotation(apiDataCommon);
		}

		return response;
	}
);

const dtheQuotationSlice = createSlice({
  name,
  initialState,
  reducers: {
    resetState: (state) => {
      state.quotations = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addDTHEQuotationAsync.pending, (state) => {
        state.error = null;
      })
      .addCase(addDTHEQuotationAsync.fulfilled, (state, action) => {
        state.quotations = action.payload;
      })
      .addCase(addDTHEQuotationAsync.rejected, (state, action) => {
        state.error = action.error;
      });
  },
});

export const dtheQuotationActions = {
  ...dtheQuotationSlice.actions,
  addDTHEQuotationAsync,
};

export const dtheQuotationsReducer = dtheQuotationSlice.reducer;


